import pl from "@locales/monitoring/pl.json";
import en from "@locales/monitoring/en.json";
export default {
  pl: pl,
  en: en,
};
